export class ConfigNotLoadFromServerError extends Error {
  constructor() {
    super('Конфигурация для модуля не была загружена с сервера')
  }
}